import { axiosInstance } from ".";

export type TotalCompanyRank = {
  total: number;
  rank: number;
  previous_rank: number;
};

/**
 * 自社ランキング取得 (総合)
 */
export const getCompanyRank = async () => {
  const response = await axiosInstance.get<TotalCompanyRank>(
    `/api/v1/company_info/rankings`
  );

  return response;
};

export type CompanyRankByBusinessCategory = TotalCompanyRank & {
  business_category_name: string;
};

/**
 * 自社ランキング取得 (業種別)
 */
export const getCompanyRankByBusinessCategory = async () => {
  const response = await axiosInstance.get<CompanyRankByBusinessCategory>(
    `/api/v1/company_info/business_category_rankings`
  );

  return response;
};

export type CompanyRankByGraduateYear = TotalCompanyRank & {
  graduate_year: number;
};

/**
 * 自社ランキング取得 (最新3卒年)
 */
export const getCompanyRanksByGraduateYear = async () => {
  const response = await axiosInstance.get<CompanyRankByGraduateYear[]>(
    `/api/v1/company_info/graduate_year_rankings`
  );

  return response;
};

export type CompanyRankByUniversity = TotalCompanyRank & {
  university_name: string;
  university_id: string;
};

/**
 * 自社ランキング取得 (最新フォロー3大学)
 */
export const getCompanyRanksByUniversity = async () => {
  const response = await axiosInstance.get<CompanyRankByUniversity[]>(
    `/api/v1/company_info/university_rankings`
  );

  return response;
};
